export const getCgateToken = (() => {
  let inner_token: string | undefined
  return () => {
    if (!inner_token) {
      const state = (window as any).g_app._store.getState('user')
      const { common } = state.user
      inner_token = common.cgate_auth
    }

    return inner_token
  }
})()

export const getTenantId = (() => {
  let inner_tenant_id: string | undefined
  return () => {
    if (!inner_tenant_id) {
      const state = (window as any).g_app._store.getState('user')
      inner_tenant_id = state.user.company_info?.pri_center_id
    }
    return inner_tenant_id
  }
})()

export const isDev = process.env.NODE_ENV === 'development'

export const isTest = () => window.location.host.includes('dev') || isDev

const DEFAULT_CGATE_ORIGIN = isTest()
  ? 'https://cgate-dev-lane.xiaoduoai.com'
  : 'https://cgate.xiaoduoai.com'

export const cgateFetch = <T>(
  urlOrPath: string,
  options: Omit<RequestInit, 'headers'> & {
    headers?: Record<string, string>
    callerApp: string
    cgateToken?: string
  }
): Promise<T> => {
  const combineUrl = urlOrPath.startsWith('http')
    ? urlOrPath
    : `${DEFAULT_CGATE_ORIGIN}${urlOrPath.startsWith('/') ? urlOrPath : `/${urlOrPath}`}`
  const { headers: originalHeaders, callerApp, cgateToken, ...extraOptions } = options
  const defaultHeaders: RequestInit['headers'] = {
    Authorization: `Bearer ${cgateToken ?? getCgateToken()}`,
  }
  if (options && options.method && options.method.toLocaleUpperCase() !== 'GET') {
    defaultHeaders['Content-Type'] = 'application/json'
  }
  const headers: Record<string, string> = {
    ...defaultHeaders,
    ...originalHeaders,
  }
  headers['xd-metadata'] = `caller_app=${callerApp}||tenant_id=${getTenantId()}`

  const init: RequestInit = {
    mode: 'cors',
    headers,
    ...extraOptions,
  }

  return fetch(combineUrl, init).then((res) => res.json())
}
